// extracted by mini-css-extract-plugin
module.exports = {"layout":"install_layout__1tMWr","container":"install_container__2xV5A","img":"install_img__2QFuk"};